import { useState, useCallback } from "react";

export const useExpandCollapse = (initialState = {}) => {
    const [expandedItems, setExpandedItems] = useState(initialState);

    const toggleItem = useCallback((itemId) => {
        setExpandedItems(prev => ({ ...prev, [itemId]: !prev[itemId] }));
    }, []);

    const isExpanded = useCallback((itemId) => {
        return expandedItems[itemId] !== false;
    }, [expandedItems]);

    const setAllExpanded = useCallback((items, expanded = true) => {
        const newState = {};
        items.forEach(item => {
            newState[item] = expanded;
        });
        setExpandedItems(newState);
    }, []);

    return {
        expandedItems,
        setExpandedItems,
        toggleItem,
        isExpanded,
        setAllExpanded
    };
};

export const useExpandCollapseList = (initialList = []) => {
    const [expandedList, setExpandedList] = useState(initialList);

    const toggleItem = useCallback((itemId) => {
        setExpandedList(prev => 
            prev.includes(itemId) 
                ? prev.filter(id => id !== itemId)
                : [...prev, itemId]
        );
    }, []);

    const isExpanded = useCallback((itemId) => {
        return expandedList.includes(itemId);
    }, [expandedList]);

    return {
        expandedList,
        setExpandedList,
        toggleItem,
        isExpanded
    };
};

